import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Expense } from '../models/expense';
import { ExpenseType } from '../models/expense-type';
import { Tollbooth } from '../models/tollbooth';
import { EtType } from '../et-type';
import { ExpenseRoute } from '../expense-route';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {
  
  constructor(private http:HttpClient) { }

  async getExpenses(variable?:string, value?:string) : Promise<Expense[]> {
    return this.http.get<Expense[]>('/api/expense' + (variable ? "?" + variable + "=" + value : ""))
      .toPromise()
  }

  async postExpense(expense:Expense) : Promise<Expense> {
    return this.http.post<Expense>('/api/expense', expense).toPromise();
  }

  async getExpense(id:Number) : Promise<Expense> {
    return this.http.get<Expense>('/api/expense/' + id).toPromise();
  }
  
  async putExpense(expense:Expense) : Promise<Expense> {
    return this.http.post<Expense>('/api/expense/' + expense.id + '/edit', expense).toPromise();
  }
  
  async deleteExpense(expense:Expense) : Promise<void> {
    return this.http.get<void>('/api/expense/' + expense.id + '/delete').toPromise();
  }

  async getExpenseTypes() : Promise<ExpenseType[]> {
    return this.http.get<ExpenseType[]>('/api/all/expense/types').toPromise();
  }

  async getTollbooth():Promise<Tollbooth[]>{
    return this.http.get<Tollbooth[]>('/api/tollbooth').toPromise();
  }

  async updateTollboothByExcel(by:string,file):Promise<any>{
    const formData:FormData = new FormData();
    formData.append('by',by);
    formData.append('expenses',file,file.name);
    return this.http.post<any>('/api/expense/tollbooth',formData).toPromise();
  }

  async getExpenseByRoute(id: number): Promise<ExpenseRoute[]>{
    return this.http.get<ExpenseRoute[]>('/api/expense/route/' + id).toPromise();
  }

  async updateExpensesRoute(id:number, expRoute: ExpenseRoute[]) : Promise<ExpenseRoute[]> {
    return this.http.post<ExpenseRoute[]>('/api/expense/route/'+ id +'/edit', {expRoute}).toPromise();
  }

  /**
   * postNewLine(id:number, lines:TravelLine[], expenses:TravelExpense[]) : Promise<Travel> {
       return this.http.post<Travel>('/api/travel/' + id + '/edit/newline', {lines, expenses}).toPromise();
     }
   */
  async postExpenseType(expType: ExpenseType) : Promise<ExpenseType[]>{
    return this.http.post<ExpenseType[]>('/api/expense-type', expType).toPromise();
  }

  async putExpenseType(expType: ExpenseType) : Promise<ExpenseType[]>{
    return this.http.post<ExpenseType[]>('/api/expense-type/' + expType.id + '/edit', expType).toPromise();
  }

  async deleteExpenseTypes(expType: ExpenseType): Promise<ExpenseType[]>{
    return this.http.post<ExpenseType[]>('/api/expense-type/' + expType.id + '/delete', {}).toPromise();
  }

  async getEtTypes(): Promise<EtType[]>{
    return this.http.get<EtType[]>('/api/all/et-type').toPromise();
  }
}
